
export default {
  name: 'about',
  components: {

  },
  data() {
    return {
      datas: {

      }
    }
  },
  created() {

  },
  mounted: function () {
  },
  methods: {
    backPage: function () {
      window.history.go(-1)
    },
    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      oInput.remove()
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/about/about.js